import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { AppLayer, FishboneLayer } from './layer.service';
import { CardDisplayMode } from 'app/components/content-edit/edit-card/edit-card.component';
import { StackedAddressItem } from 'app/components/feat-edit/address-manage/stacked-addresses-pick/stacked-addresses-pick.component';

export type ParentLayerStateType = 'inside' | 'border' | 'congruent';
export interface ParentLayer {
	cateCode: string;
	layerId?;
}

export type TabKey = 'data' | 'data-addr' | 'data-centerline' | 'resoCenter' | 'resoCenter_domain' | 'filterOptions' | 'batch' | 'exception' | 'a3i' | 'schema' | 'topoCheck' | 'bookmarkRef';

@Injectable({
	providedIn: 'root'
})
export class ActivityService {

	hoverCoord: Subject<{
		coord: number[]
	}> = new Subject();

	displayedLayerListBS: BehaviorSubject<{layers: AppLayer[];}> = new BehaviorSubject({
		layers: []
	});
	selectedLayerBS: BehaviorSubject<{
		layer: AppLayer;
		keepFilters?: boolean;
		source?: 'onSelectLayer'
	}> = new BehaviorSubject({
		layer: null
	});
	bgRefLayerChange: Subject<any> = new Subject(); // bg ref change

	parentLayerBS: BehaviorSubject<{
		layer?: ParentLayer,
		state?: ParentLayerStateType
	}> = new BehaviorSubject(null);

	mapFilterBS: BehaviorSubject<{isOn: boolean;}> = new BehaviorSubject({
		isOn: false
	});
	mapFilterDisableBS: BehaviorSubject<{disabled: boolean}> = new BehaviorSubject({
		disabled: false
	});
	mapMoveProcessingBS: BehaviorSubject<{isProcessing: boolean}> = new BehaviorSubject(null);

	// selectedRecord: BehaviorSubject<{id: string; source?: 'table' | 'map' | 'card'}> = new BehaviorSubject(null);
	selectedRecordsBS: BehaviorSubject<{
		ids: (string | number)[];
		addIds?: string[];
		removeIds?: string[];
		source?: 'table' | 'map';
		zoomToRec?: boolean;
	}> = new BehaviorSubject(null);
	currentCardBS: BehaviorSubject<{
		id;
		source?: 'card' | 'main';
	}> = new BehaviorSubject(null);
	editRecordListBS: BehaviorSubject<{
		// list: any[];
		ids: any[];
		source?: 'card' | 'main';
	}> = new BehaviorSubject({
		// list: []
		ids: []
	});
	editRecordHoldListBS: BehaviorSubject<{
		ids: any[];
		source?: 'geomEdit'
	}> = new BehaviorSubject({
		ids: []
	});
	editRecordListHiddenBS: BehaviorSubject<{
		// list: any[];
		ids: any[];
		source?: 'card' | 'main';
	}> = new BehaviorSubject({
		// list: []
		ids: []
	});
	stackAddressesSelectBS: BehaviorSubject<{
		isOpen?: boolean;
		list?: StackedAddressItem[];
		position?: number[] // pixel position relative to map
	}> = new BehaviorSubject({});

	selectedTabBS: BehaviorSubject<{tabKey: TabKey}> = new BehaviorSubject({
		tabKey: null
	});

	batchFilterCount: BehaviorSubject<{count: number}> = new BehaviorSubject({
		count: null
	});

	applyAttrFilterSubject: Subject<any> = new Subject();

	refreshData: Subject<{updateLayerList?: boolean; updateSchema?: boolean}> = new Subject();

	cancelChangesSubject: Subject<any> = new Subject();

	networkTopoMode: BehaviorSubject<{isOn: boolean}> = new BehaviorSubject({
		isOn: true
	});

	// Is current data sample
	isDataSample: BehaviorSubject<boolean> = new BehaviorSubject(true);
	// Sql whereClause (that CAN contain qa codes) (which is used to get current data)
	// used for batch update
	sqlForBatch: string;

	updateExceptionsSubject: Subject<any> = new Subject();

	resetFeatures: Subject<{ids: any[]}> = new Subject();

	changeTabSubject: Subject<{
		tabKey: string;
		dataTabMode?: CardDisplayMode;
	}> = new Subject();
	constructor() { }

	removeCurrentSelection() {
		const selection = this.selectedRecordsBS.getValue();
		if (selection && selection.ids && selection.ids.length) {
			this.selectedRecordsBS.next({
				ids: []
			});
		}
	}
}
